<template>
    <section class="py-16 section_services bg-gradient-to-br from-green-400 to-green-500">
      <div class="container mx-auto px-4">
        <h2 class="text-4xl pt-8 font-bold text-center mb-12 text-white">
          {{ t("services.servicesTitle") }}
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <TransitionGroup name="service-list" tag="div" class="contents" appear>
            <div
              v-for="service in services"
              :key="service.id"
              class="service-item bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div class="flex flex-col items-center text-center">
                <div class="text-5xl mb-4 text-indigo-600">
                  <component :is="service.icon" />
                </div>
                <h3 class="text-2xl font-semibold mb-3 text-gray-800">
                  {{ t(`services.${service.name}`) }}
                </h3>
                <p class="text-gray-600">
                  {{ t(`services.${service.description}`) }}
                </p>
              </div>
            </div>
          </TransitionGroup>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref } from "vue";
  import { WrenchIcon, RefreshCwIcon } from "lucide-vue-next";
  import { useI18n } from "vue-i18n"; // دعم الترجمة
  
  const { t } = useI18n();
  
  const services = ref([
    {
      id: 1,
      name: "installation",
      description: "installationDesc",
      icon: WrenchIcon,
    },
    {
      id: 2,
      name: "maintenance",
      description: "maintenanceDesc",
      icon: RefreshCwIcon,
    },
    {
      id: 3,
      name: "commissioning",
      description: "commissioningDesc",
      icon: WrenchIcon,
    },
  ]);
  </script>
  
  <style scoped>
  .service-list-move,
  .service-list-enter-active,
  .service-list-leave-active {
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  }
  
  .service-list-enter-from,
  .service-list-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
  
  .service-list-leave-active {
    position: absolute;
  }
  
  @keyframes float {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
  
  .service-item {
    animation: float 6s ease-in-out infinite;
  }
  
  .service-item:hover {
    animation-play-state: paused;
  }
  </style>
  